import { takeLatest, put } from 'redux-saga/effects';
import { getMerchants } from '../../app/components/api/merchants';

export const actionTypes = {
	GetMerchants: '[Merchants] GetMerchants',
	SetMerchants: '[Merchants] SetMerchants',
	UpdateFilter: '[Global] UpdateFilter',
	updateLoading: '[Global] updateLoading',
};

const initialState = {
	merchants: [],
	filter: {
		merchantId: '',
		from: '',
		to: '',
	},
	isCalendarLoading: false,
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SetMerchants:
			return {
				...state,
				merchants: action.payload,
			};
		case actionTypes.UpdateFilter:
			return {
				...state,
				filter: { ...state.filter, ...action.payload },
			};
		case actionTypes.updateLoading:
			return {
				...state,
				isCalendarLoading: action.payload.isCalendarLoading,
			};
		default:
			return state;
	}
};

export const actions = {
	setMerchants: (payload) => ({ type: actionTypes.SetMerchants, payload }),
	getMerchants: (payload) => ({ type: actionTypes.GetMerchants, payload }),
	updateFilter: (payload) => ({ type: actionTypes.UpdateFilter, payload }),
};
export const merchantActions = {
	updateLoading: (payload) => ({ type: actionTypes.updateLoading, payload }),
};

export function* saga() {
	yield takeLatest(actionTypes.GetMerchants, function* setMerchants() {
		const merchants = yield getMerchants();
		yield put(actions.setMerchants(merchants));
	});
}
